import { ArrowLongRightIcon, DevicePhoneMobileIcon } from '@heroicons/react/24/outline'
import { Link, ScrollRestoration } from 'react-router-dom'
import Advantages from "../assets/img/five.png";
import Title from '../components/title';
import Advantages2 from "../assets/img/six.png";
import Sylviane from "../assets/img/Sylviane.jpg";
import Icotype from "../assets/img/icotype.png"
import Footer from '../components/footer';
import ICONS_ACC from "../assets/img/ICONS_Accompagnement.svg"
import ICONS_ART from "../assets/img/ICONS_Articulation.svg"
import ICONS_CONF from "../assets/img/ICONS_Conferences.svg"
import ICONS_ETU from "../assets/img/ICONS_Etudes.svg"
import ICONS_RECO from "../assets/img/ICONS_Recommandations.svg"
import ICONS_SERV from "../assets/img/ICONS_Service.svg"
import ICONS_SOLU from "../assets/img/ICONS_Solutions.svg"

export default function Dashboard() {

    const prestations = [
        { "icon": ICONS_RECO, to: "/strategie-retraite/", "name": "Des recommandations", "description": "Pour accompagner la \u00ab stratégie retraite \u00bb, pour des carrières en France et à l'international. " },
        { "icon": ICONS_SERV, to: "/bilan-retraite/", "name": "Un service personnalisé de bilans retraite", "description": "Auprès de personnes ayant eu des parcours complexes (France/International, Privé/Public)." },
        { "icon": ICONS_ART, to: "/articulation-chomage-retraite/", "name": "Articulation chômage / retraite", "description": "Evaluations sur mesure." },
        { "icon": ICONS_SOLU, to: "/solutions-optimisation/", "name": "Des solutions complètes d'optimisation", "description": "Missions de conseil auprès des Ressources Humaines pour maintenir les seniors dans l'emploi et missions auprès des entreprises pour un accompagnement personnalisé de leurs salariés de plus de 55 ans." },
        { "icon": ICONS_ETU, to: "/retour-expatriation/", "name": "Des études comparatives lors d'un départ ou d'un retour d'expatriation", "description": "Intégration des périodes travaillées à l'étranger, incident CFE, cotisations AGIRC-ARRCO International." },
        { "icon": ICONS_CONF, to: "/nos-conferences/", "name": "Des conférences spécifiques", "description": "Dans le domaine de la retraite, en fonction de la législation applicable." },
        { "icon": ICONS_ACC, to: "/liquidations-retraite/", "name": "Un accompagnement pour les liquidations de retraite", "description": "Mise en place des dossiers." },
    ]
    

    return (
        <>
           <section id="dashboard" className="w-full py-36 md:py-0 md:h-screen bg-homescreen bg-cover lg:bg-right bg-left">
                <div className='container m-auto grid sm:grid-cols-1 gap-4 h-full text-white z-10 pt-20 flex items-center justify-center'>
                    <div className='2xl:px-32 xl:px-24 lg:px-16 px-8'>
                        <h1 className='2xl:text-6xl xl:text-5xl lg:text-4xl text-3xl font-extrabold'>
                           Expertise & Benefits, un cabinet conseil spécialisé en bilans retraite, études en optimisation fin de carrière
                        </h1>                       
                    </div>                    
                </div>
           </section>

           <section id="prestations" className="bg-beige py-20">
                <div className="container mx-auto h-full text-black">
                    <div className="flex flex-col">
                        <h2 className="m-auto 2xl:text-5xl xl:text-4xl lg:text-3xl text-2xl pt-6">
                            Nos missions
                        </h2>
                        <p className="m-auto text-lg md:px-24 px-6 pt-6">
                            Le cabinet Expertise & Benefits propose :
                        </p>
                    </div>
                    
                    <div className="grid grid-cols-1 gap-x-4 gap-y-10 md:px-10 px-2 pt-10 text-lg">
                        {prestations.map(item =>
                            <div key={item.name} className='grid grid-cols-12'>
                                <div className="col-span-2 md:col-span-1 flex">
                                    <div className='mx-auto mt-0 w-6'>
                                        <img src={item.icon} className='w-100' alt={"SVG" + item.to} />
                                    </div>
                                </div>
                                <div className="col-span-10 md:col-span-3 flex">
                                    <Link to={item.to} className='mt-0 font-extrabold hover:underline '>
                                        {item.name}
                                    </Link>
                                </div>
                                <div className="col-span-12 md:col-span-8 flex pl-5">
                                    <div className='mt-0'>
                                        {item.description}
                                    </div>
                                </div>           
                            </div>                            
                        )}
                    </div>
                </div>                
           </section>

           <hr className='bg-blues h-5 w-full' />
           
            <section className="overflow-hidden bg-white py-24 sm:py-32">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                        <div className="col-span-1 md:-ml-4 lg:-ml-0">           
                            <div className="lg:max-w-lg">
                                <h2 className="m-auto 2xl:text-5xl xl:text-4xl lg:text-3xl text-2xl pt-6">
                                    Nos Atouts <ArrowLongRightIcon className='w-10 pl-4 my-auto inline' />
                                </h2>
                                <p className="m-auto pt-6 text-lg">
                                    Nous nous adaptons à chaque mission, qu'elle soit individuelle ou collective au sein d'une entreprise, pour répondre individuellement aux préoccupations de chacun concernant la retraite.
                                </p>
                                <p className="m-auto pt-6 text-lg">
                                    Nous vous proposons des estimations sur-mesure avec des calculs détaillés ainsi que des commentaires adaptés à chaque situation.
                                </p>
                                <p className="m-auto pt-6 text-lg">
                                    Nous suivons au plus près les évolutions législatives dans le domaine de la retraite et du chômage.
                                </p>
                                <p className="m-auto pt-6 text-lg">
                                    Nous intervenons sur des reconstitutions de carrière en France et à l'international.
                                </p>
                                
                            </div>
                        </div>

                        <div className="col-span-1 md:-ml-4 lg:-ml-0 relative hidden lg:block z-0">           
                            <div className="lg:max-w-lg">
                                <img src={Advantages} className="w-3/4 absolute top-0 left-0 z-10" alt="Advantages 1" />
                                <img src={Advantages2} className='w-3/5 absolute bottom-0 right-0 z-10' alt="Advantages 2" />
                                <div className='absolute w-2/3 h-2/3 bg-oranges top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-0'></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="overflow-hidden bg-white py-24 sm:py-32 bg-grays">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto grid max-w-2xl md:grid-cols-2 gap-x-16 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">                        
                        <div className="col-span-1 md:-ml-4 lg:-ml-0 relative flex my-auto relative">           
                            <div className='w-1/2 mx-2'>
                                <img src={Sylviane} className='w-full bg-origin-content bg-center rounded-xl' alt="Profil Sylviane" />
                            </div>
                            <div className='w-1/2 mx-2'>                                
                            </div>
                            <img src={Icotype} className='absolute bottom-0 z-0' alt="Icone" />
                        </div>

                        <div className="col-span-1 md:-ml-4 lg:-ml-0">           
                            <div className="lg:max-w-lg">
                                <h2 className="m-auto 2xl:text-5xl xl:text-4xl lg:text-3xl text-2xl pt-6">
                                    Nos expertes <ArrowLongRightIcon className='w-10 pl-4 my-auto inline' />
                                </h2>                               
                                <p className="m-auto pt-6 text-lg">
                                    Une solide expérience professionnelle dans les Ressources Humaines au sein de grands groupes nous permettent de nous adapter à vos besoins spécifiques et de vous faire bénéficier de notre savoir-faire dans ce domaine.
                                </p>
                                <div className='lg:flex mt-6 text-lg'>
                                    <div className='mr-auto '>
                                        <div className='h-4 w-4 bg-oranges rounded-3xl inline-flex mr-6'></div>
                                        <p className='inline-flex font-extrabold'>Sylviane Aguirre</p>
                                    </div>

                                    <div className='ml-auto'>
                                        
                                    </div>
                                </div>
                                <div className='mt-16 lg:flex'>
                                    <Link to="/nos-expertes" className="w-fit mr-auto lg:m-auto px-2 lg:px-6 py-4 bg-green text-white shadow-xl rounded-xl hover:bg-black flex">
                                        <span className='inline my-auto'>En savoir plus</span>
                                        <ArrowLongRightIcon className='w-6 inline ml-4 my-auto' />
                                    </Link>
                                    
                                    <Link to="/" className="m-auto px-2 py-4 text-white flex">
                                        <DevicePhoneMobileIcon className='w-10 p-2 rounded-xl bg-green inline mr-4 my-auto' />
                                        <div className='inline my-auto font-extrabold text-black'>
                                            <p> Contactez-nous</p>
                                            <p>07 87 10 09 05</p>
                                        </div>
                                    </Link>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

            <ScrollRestoration />
        </>
    )
}